import api from 'utils/api';

export const endpoints = {
  list: () => `/commons/policies/eskolare/`,
  accept: () => `/commons/accept-policies/`,
};

/**
 * Documentation:
 */
export function accept({ policies }) {
  const options = {
    method: 'post',
    url: endpoints.accept(),
    data: { policies },
  };
  return api(options);
}
